import axios from "../../axios";

const state = {
  page: 1,
  loadingSearch: false,

  groups: [],
  selectedGroup: null,
  lastUpdatedGroups: null,
  selectedCategory: null,
  prods: [],
  searchType: null,
};

const getters = {
  retrievePage: (state) => {
    return state.page;
  },

  retrieveLoadingSearch: (state) => {
    return state.loadingSearch;
  },

  retrieveGroups: (state) => {
    return state.groups;
  },

  retrieveLastUpdatedGroups: (state) => {
    return state.lastUpdatedGroups;
  },

  retrieveSelectedGroup: (state) => {
    let currentItem = false;

    state.groups.forEach((item) => {
      if (state.selectedGroup == item.group_no) {
        currentItem = item;
      }
    });

    return currentItem;
  },

  retrieveProducts: (state) => {
    return state.prods;
  },

  retrieveSearchType: (state) => {
    return state.searchType;
  },
};

const actions = {
  setPage({ commit }, payload) {
    const response = commit("setPage", payload);
    return response;
  },

  setLoadingSearch({ commit }, payload) {
    const response = commit("setLoadingSearch", payload);
    return response;
  },

  setGroups({ commit }, payload) {
    const response = commit("setGroups", payload);
    return response;
  },

  clearGroups({ commit }, payload) {
    const response = commit("setGroups", []);
    return response;
  },

  setProducts({ commit }) {
    const response = commit("setProducts", payload);
    return response;
  },

  clearProducts({ commit }) {
    const response = commit("setProducts", []);
    return response;
  },

  async productSearch({ commit }, payload) {
    let result = false;

    const params = new URLSearchParams();
    params.append("params", payload);

    commit("setPage", 1);
    commit("setSelectedGroup", null);
    commit("setLoadingSearch", true);

    const response = await axios
      .post("products/product-search", params)
      .catch((e) => {
        console.log(e);
        return false;
      });

    commit("setLoadingSearch", false);

    if (response) {
      if (response.data.success) {
        commit("setProducts", response.data.prods);
        result = true;
      }
    }

    return result;
  },

  async getMandatoryCategory({ commit }) {
    let result = false;

    let payload = JSON.stringify({
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      orderDate: this.getters.retrieveCurrentTrolly.order_date,
      catNum: this.getters.retrieveCurrentTrolly.mandatory_cat.category_no,
      template: 1,
      customerNo: this.getters.retrieveSelectedCustomer,
    });

    const params = new URLSearchParams();
    params.append("params", payload);

    commit("setLoadingSearch", true);
    const response = await axios.post("products/get-cat-price-list", params);
    commit("setPage", 1);
    commit("setSelectedGroup", null);

    commit("setLoadingSearch", false);
    commit("setSearchType", null);

    if (response.data.success) {
      commit("setProducts", response.data.prods);
      result = true;
    }

    return result;
  },

  async getCatPriceList({ commit }, payload) {
    let result = false;

    const params = new URLSearchParams();
    params.append("params", payload);

    commit("setLoadingSearch", true);
    const response = await axios.post("products/get-cat-price-list", params);
    commit("setPage", 1);
    commit("setSelectedGroup", null);

    commit("setLoadingSearch", false);
    commit("setSearchType", null);

    if (response.data.success) {
      commit("setProducts", response.data.prods);
      result = true;
    }

    return result;
  },

  async getGroupPriceList({ commit }, { payload, description }) {
    let result = false;

    const params = new URLSearchParams();
    params.append("params", payload);

    console.log("-- Payload");
    console.log(payload);

    commit("setLoadingSearch", true);
    const response = await axios.post("products/get-group-price-list", params);
    commit("setPage", 1);
    commit("setSelectedGroup", JSON.parse(payload).groupNum);

    commit("setLoadingSearch", false);
    commit("setSearchType", null);

    if (response.data.success) {
      commit("setProducts", response.data.prods);
      result = true;
    }

    return result;
  },

  async getCategoryPriceList({ commit }, { payload, description }) {
    let result = false;

    const params = new URLSearchParams();
    params.append("params", payload);

    commit("setLoadingSearch", true);
    const response = await axios.post("products/get-cat-price-list", params);
    commit("setPage", 1);
    commit("setSelectedCategory", JSON.parse(payload).catNum);

    commit("setLoadingSearch", false);
    commit("setSearchType", description);

    if (response.data.success) {
      commit("setProducts", response.data.prods);
      result = true;
    }

    return result;
  },

  async getFavourites({ commit }, payload) {
    let result = false;

    const params = new URLSearchParams();
    params.append("params", payload);

    let favouritesFunction = "get-favourites";

    if (this.getters.retrieveAdmin.account_type == "C1") {
      if (
        (this.getters.retrieveIsCashCustomer && !this.getters.retrieveGuest) ||
        (this.getters.retrieveIsCncCustomer && !this.getters.retrieveGuest)
      ) {
        favouritesFunction = "get-user-favourite";
      }
    } else {
      favouritesFunction = "get-user-favourite";
    }

    commit("setLoadingSearch", true);
    const response = await axios.post(
      "favourite/" + favouritesFunction,
      params
    );
    commit("setPage", 1);
    commit("setSelectedGroup", null);

    commit("setLoadingSearch", false);
    commit("setSearchType", "Favourites");

    if (response.data.success) {
      commit("setProducts", response.data.prods);
      result = true;
    }

    return result;
  },

  async getPromotions({ commit, rootGetters }, payload) {
    let result = false;

    const params = new URLSearchParams();
    params.append("params", payload);

    commit("setLoadingSearch", true);
    const response = await axios.post("products/get-promotions", params);
    commit("setPage", 1);
    commit("setSelectedGroup", null);
    let typeText = "Promotions";
    if (
      rootGetters.retrieveAllConfigs.promo_btn_text &&
      rootGetters.retrieveAllConfigs.promo_btn_text != ""
    ) {
      typeText = rootGetters.retrieveAllConfigs.promo_btn_text;
    }

    commit("setLoadingSearch", false);
    commit("setSearchType", typeText);

    if (response.data.success) {
      commit("setProducts", response.data.prods);
      result = true;
    }

    return result;
  },

  async getNewProducts({ commit }, payload) {
    let result = false;

    const params = new URLSearchParams();
    params.append("params", payload);

    commit("setLoadingSearch", true);
    const response = await axios.post("products/get-new-prods", params);
    commit("setPage", 1);
    commit("setSelectedGroup", null);

    commit("setLoadingSearch", false);
    commit("setSearchType", "New Products");

    if (response.data.success) {
      commit("setProducts", response.data.prods);
      result = true;
    }

    return result;
  },

  clearTemplate({ commit }) {
    commit("setPage", 1);
    commit("setLoadingSearch", false);
    commit("setGroups", []);
    commit("setSelectedGroup", null);
    commit("setProducts", []);
  },
};

const mutations = {
  setPage: (state, value) => (state.page = value),
  setLoadingSearch: (state, value) => (state.loadingSearch = value),

  setGroups: (state, value) => (
    (state.groups = value), (state.lastUpdatedGroups = new Date().getTime())
  ),
  setSelectedGroup: (state, value) => (state.selectedGroup = value),

  setSelectedCategory: (state, value) => (state.selectedCategory = value),

  setProducts: (state, value) => (state.prods = value),
  setSearchType: (state, value) => (state.searchType = value),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
